<template>
  <el-card>
    <div slot="header">
      Alapadatok
    </div>
    <el-form
      ref="basicDataForm"
      :model="basicData"
      label-position="top"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Cég hivatalos neve"
            prop="name"
          >
            <el-input
              v-model="basicData.name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Cég rövid neve">
            <el-input
              v-model="basicData.short_name"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Adószám" prop="tax_number">
            <el-input
              v-model="basicData.tax_number"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="EU adószám">
            <el-input
              v-model="basicData.eu_tax_number"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Telefon">
            <el-input
              v-model="basicData.phone"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="E-mail">
            <el-input
              v-model="basicData.email"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label=Honlap>
            <el-input
              v-model="basicData.web"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Fax"
            prop="fax"
          >
            <el-input
              v-model="basicData.fax"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="FELIR"
            prop="felir"
          >
            <el-input
              v-model="basicData.felir"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Cégjegyzékszám"
            prop="registration_number"
          >
            <el-input
              v-model="basicData.registration_number"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="ILN">
            <el-input
              v-model="basicData.iln"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
export default {
  props: ['ownCompany'],
  data() {
    return {
      basicData: {},
      rules: {
        name: [
          {
            required: true,
            message: 'Cégnév megadása kötelező',
            trigger: 'change'
          }
        ],
      }
    };
  },
  watch: {
    ownCompany(newVal) {
      this.basicData = Object.assign({}, newVal);
    },
  },
};
</script>
